import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { User } from "@/types/auth";
import type { Team } from "@/types/team";

interface AuthState {
  token: string | null;
  user: User | null;
  isAuthenticated: boolean;
  activeTeamId: string | null;
  teams: Team[];
  setAuth: (token: string, user: User) => void;
  setToken: (token: string) => void;
  setUser: (user: User) => void;
  setActiveTeam: (teamId: string) => void;
  setTeams: (teams: Team[]) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      isAuthenticated: false,
      activeTeamId: null,
      teams: [],

      setAuth: (token, user) =>
        set({
          token,
          user,
          isAuthenticated: true,
          activeTeamId: user.active_team_id ?? null,
        }),

      setToken: (token) => set({ token }),

      setUser: (user) => set({ user }),

      setActiveTeam: (teamId) => set({ activeTeamId: teamId }),

      setTeams: (teams) => set({ teams }),

      logout: () =>
        set({
          token: null,
          user: null,
          isAuthenticated: false,
          activeTeamId: null,
          teams: [],
        }),
    }),
    {
      name: "motionforge-auth",
      partialize: (state) => ({
        token: state.token,
        user: state.user,
        isAuthenticated: state.isAuthenticated,
        activeTeamId: state.activeTeamId,
      }),
    },
  ),
);
